class ShopTheLookDrawer extends HTMLElement {
  constructor() {
    super();
    this._boundHandleKeyup = (e) => {
      if (e.code?.toUpperCase() === 'ESCAPE') this.close();
    };
    this.addEventListener('keyup', this._boundHandleKeyup);
  }

  connectedCallback() {
    this.openButton = this.querySelector('[data-shop-the-look-open]');
    this._boundToggle = this.toggle.bind(this);
    this.openButton?.addEventListener('click', this._boundToggle);
  }

  disconnectedCallback() {
    this.removeEventListener('keyup', this._boundHandleKeyup);
    this.openButton?.removeEventListener('click', this._boundToggle);
  }

  get slide() {
    return this.closest('[data-shop-the-look-slide]');
  }

  get isOpen() {
    return !this.classList.contains('shop-the-look-overlay--hidden');
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.classList.remove('shop-the-look-overlay--hidden');
    this.slide?.classList.add('is-drawer-open');
    this.openButton?.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.classList.add('shop-the-look-overlay--hidden');
    this.slide?.classList.remove('is-drawer-open');
    this.openButton?.setAttribute('aria-expanded', 'false');
    this.openButton?.focus();
  }
}

customElements.define('shop-the-look-drawer', ShopTheLookDrawer);
